var render = function render(){var _vm=this,_c=_vm._self._c;return _c('samp',[_vm._v(_vm._s(_vm.minuteVal))])
}
var staticRenderFns = []

export { render, staticRenderFns }